export default __webpack_public_path__ + "static/media/bg_campaign.f94e262a.jpg";